import { mdiAccountCancel } from '@mdi/js';
import { BaseTable, ColumnProp } from 'common/components/table/base';
import { DEFAULT_PAGE_SIZE } from 'common/components/table/config';
import { TableTitle } from 'common/components/tables';
import { useProducerWithThunks } from 'common/hooks/useProducer';
import { XactAccount } from 'common/state/banking/actions';
import { userXactAccountsRecipe } from 'common/state/banking/recipes';
import { defaultUserXactAccountState } from 'common/state/banking/states';
import { doGetUserXactAccounts } from 'common/state/banking/thunkActions';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { CustomerParams } from '../customer';

export const UsernameLink = styled(Link)`
  width: fit-content;
  padding-bottom: 0.125rem;
  border-bottom: 1px dashed;
  cursor: pointer;
  color: inherit;
  text-decoration: none;
`;

export const XactAccountsTable = () => {
  const { username } = useParams<CustomerParams>();
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [xactAccountsState, xactAccountsDispatch] = useProducerWithThunks(
    userXactAccountsRecipe,
    defaultUserXactAccountState
  );

  useEffect(() => {
    xactAccountsDispatch(
      doGetUserXactAccounts(username, {
        limit: pageSize,
        offset: pageSize * (pageNo - 1),
      })
    );
  }, [xactAccountsDispatch, username, pageSize, pageNo]);

  const columns = useMemo(
    (): ColumnProp<XactAccount>[] => [
      {
        key: 'full_code',
        title: 'Full Code',
        valueFormatter: (row) => (
          <UsernameLink to={`/movements/${row.full_code}`}>
            {row.full_code}
          </UsernameLink>
        ),
      },
      { key: 'name', title: 'Name' },
      { key: 'currency', title: 'Currency' },
      { key: 'type', title: 'Type' },
    ],
    []
  );

  return (
    <>
      <TableTitle icon={mdiAccountCancel} title="Xact Accounts" />
      <BaseTable
        rows={xactAccountsState.accounts || []}
        columns={columns}
        pagination={{
          count: xactAccountsState.count,
          pageNo,
          pageSize,
          setPageNo,
          setPageSize,
        }}
      />
    </>
  );
};
